/* eslint-disable @typescript-eslint/no-floating-promises */
import i18n from './internationalization';
import { langCodes } from './constants/lang-codes';
import { fetchLocaleFromAssets } from './fetchAPI/fetch-locale-from-assets';

const memoryCache: Record<string, Record<string, unknown>> = {};

export const TranslationService = {
  initialized: false,
  onReadyCallbacks: [] as Array<() => void>,

  async initLocales(): Promise<void> {
    const locales = Object.values(langCodes);
    for (const locale of locales) {
      if (!memoryCache[locale]) {
        const data = await fetchLocaleFromAssets(locale);
        memoryCache[locale] = data;
        i18n.addResourceBundle(locale, 'translation', data, true, true);
      }
    }

    await new Promise<void>((resolve) => {
      if (i18n.isInitialized) resolve();
      else i18n.on('initialized', () => resolve());
    });

    this.setInitialized(true);
  },

  async changeLanguage(locale: string): Promise<void> {
    if (!memoryCache[locale]) {
      const data = await fetchLocaleFromAssets(locale);
      memoryCache[locale] = data;
      i18n.addResourceBundle(locale, 'translation', data, true, true);
    }

    await i18n.changeLanguage(locale);
    i18n.reloadResources([locale], ['translation']);
    this.setInitialized(true);
  },

  t(key: string, options?: Record<string, unknown>): string {
    return i18n.t(key, options);
  },

  setInitialized(value: boolean): void {
    this.initialized = value;
    if (value) {
      this.onReadyCallbacks.forEach((cb) => {
        try {
          cb();
        } catch (err) {
          console.error('Error in onReady callback:', err);
        }
      });
      this.onReadyCallbacks = [];
    }
  },

  onReady(callback: () => void): void {
    if (this.initialized) callback();
    else this.onReadyCallbacks.push(callback);
  },

  getCurrentLanguage(): string {
    return i18n.language;
  },

  get isReady(): boolean {
    return this.initialized && i18n.isInitialized;
  },
};
